import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";

// ✅ Import Slices
import authReducer from "./slices/authSlice";
import allUserReducer from "./slices/allUserSlice";
import allUserRoleReducer from "./slices/allUserRoleSlice";
import allUserGroupReducer from "./slices/allUserGroupSlice";
import statesReducer from "./slices/statesSlice";
import countryReducer from "./slices/countrySlice";
import allValueChainCategoriesReducer from "./slices/allValueChainCategorySlice";
import allValueChainsReducer from "./slices/allValueChainsSlice";
import agentMasterReducer from "./slices/allAgentMasterSlice";
import responsibilityCenterReducer from "./slices/responsibilityCenterSlice";
import responsibilityGroupReducer from "./slices/responsibilityGroupSlice";
import accountCategoryMasterReducer from "./slices/accountCategoryMasterSlice";
import accountMasterReducer from "./slices/accountMasterSlice";
import organizationMasterReducer from "./slices/organizationMasterSlice";
import memberCategoryMasterReducer from "./slices/memberCategoryMasterSlice";
import memberMasterReducer from "./slices/memberMasterSlice";
import scenarioMasterReducer from "./slices/scenarioMasterSlice";
import scripturalReferenceMasterReducer from "./slices/scripturalReferenceMasterSlice";
import voucherTypeFinanceMasterReducer from "./slices/voucherTypeFinanceMasterSlice";
import voucherTypeKarmaMasterReducer from "./slices/voucherTypeKarmaMasterSlice";
import voucherFinanceReducer from "./slices/voucherFinanceSlice";
import voucherKarmaReducer from "./slices/voucherKarmaSlice";
import voucherParticipantReducer from "./slices/voucherParticipantSlice";
import openingBalanceFinanceReducer from "./slices/openingBalanceFinanceSlice";
import openingBalanceKarmaReducer from "./slices/openingBalanceKarmaSlice";
import inventoryCategoryMasterReducer from "./slices/inventoryCategoryMasterSlice";
import inventoryItemMasterReducer from "./slices/inventoryItemMasterSlice";
import inventoryOpeningBalanceReducer from "./slices/inventoryOpeningBalanceSlice";
import inventoryTransactionsReducer from "./slices/inventoryTransactionsSlice";

// ✅ Import Services
import { authService } from "./services/authService";
import { allUserService } from "./services/allUserService";
import { allUserRoleService } from "./services/userRoleService";
import { allUserGroupService } from "./services/userGroupService";
import { stateService } from "./services/stateService";
import { countryService } from "./services/countryService";
import { allValueChainCategoriesService } from "./services/allValueChainCategoriesService";
import { allValueChainsService } from "./services/allValueChainsService";
import { allAgentMasterService } from "./services/allAgentMasterService";
import { responsibilityCenterService } from "./services/responsibilityCenterService";
import { responsibilityGroupService } from "./services/responsibilityGroupService";
import { accountCategoryService } from "./services/acountCategoryMasterServices";
import { accountService } from "./services/accountMasterService";
import { organizationMasterService } from "./services/organizationMasterService";
import { memberCategoryMasterService } from "./services/MemberCategoryMasterService";
import { memberMasterService } from "./services/MemberMasterService";
import { scenarioMasterService } from "./services/scenarioMasterService";
import { scripturalReferenceMasterService } from "./services/scripturalReferenceMasterService";
import { voucherTypeFinanceMasterService } from "./services/voucherTypeFinanceMasterService";
import { voucherTypeKarmaMasterService } from "./services/voucherTypeKarmaMasterService";
import { voucherKarmaService } from "./services/voucherKarmaService";
import { voucherFinanceService } from "./services/voucherFinanceService";
import { voucherParticipantService } from "./services/voucherParticipantService";
import { openingBalanceFinanceService } from "./services/openingBalanceFinanceService";
import { openingBalanceKarmaService } from "./services/openingBalanceKarmaService";
import { inventoryCategoryMasterService } from "./services/inventoryCategoryMasterService";
import { inventoryItemMasterService } from "./services/inventoryItemMasterService";
import { inventoryOpeningBalanceService } from "./services/inventoryOpeningBalanceService";
import { inventoryTransactionsService } from "./services/inventoryTransactionsService";
import tokenMechanismMasterReducer from './slices/tokenMechanismMasterSlice';
import { tokenMechanismMasterService } from './services/tokenMechanismMasterService';
import aiProcessingLogReducer from './slices/aiProcessingLogSlice';
import { aiProcessingLogService } from './services/aiProcessingLogService';
import auditLogReducer from './slices/auditLogSlice';
import { auditLogService } from './services/auditLogService';
import partyCategoryMasterReducer from './slices/partyCategoryMasterSlice';
import { partyCategoryMasterService } from './services/partyCategoryMasterService'
import dashboardReducer from './slices/dashbordSlice';
import { dashboardService } from './services/dashboardService';
import accountTypeMasterReducer from './slices/accountTypeMasterSlice';
import { accountTypeMasterService } from './services/accountTypeMasterService';
import accountLedgerReducer from './slices/accountLedgerSlice';
import { accountLedgerService } from './services/accountLedgerServices';


export const store = configureStore({
  reducer: {
    // Slices
    auth: authReducer,
    allUser: allUserReducer,
    states: statesReducer,
    country: countryReducer,
    // city: cityReducer,
    allValueChainCategories: allValueChainCategoriesReducer,
    allValueChains: allValueChainsReducer,
    agentMaster: agentMasterReducer,
    allUserRole: allUserRoleReducer,
    allUserGroup: allUserGroupReducer,
    responsibilityCenter: responsibilityCenterReducer,
    responsibilityGroup: responsibilityGroupReducer,
    accountCategoryMaster: accountCategoryMasterReducer,
    accountMaster: accountMasterReducer,
    organizationMaster: organizationMasterReducer,
    memberCategoryMaster: memberCategoryMasterReducer,
    memberMaster: memberMasterReducer,
    scenarioMaster: scenarioMasterReducer,
    scripturalReferenceMaster: scripturalReferenceMasterReducer,
    voucherTypeFinanceMaster: voucherTypeFinanceMasterReducer,
    voucherTypeKarmaMaster: voucherTypeKarmaMasterReducer,
    voucherFinance: voucherFinanceReducer,
    voucherKarma: voucherKarmaReducer,
    voucherParticipant: voucherParticipantReducer,
    openingBalanceFinance: openingBalanceFinanceReducer,
    openingBalanceKarma: openingBalanceKarmaReducer,
    inventoryCategoryMaster: inventoryCategoryMasterReducer,
    inventoryItemMaster: inventoryItemMasterReducer,
    inventoryOpeningBalance: inventoryOpeningBalanceReducer,
    inventoryTransactions: inventoryTransactionsReducer,
    tokenMechanismMaster: tokenMechanismMasterReducer,
    aiProcessingLog: aiProcessingLogReducer,
    auditLog: auditLogReducer,
    partyCategoryMaster: partyCategoryMasterReducer,
    dashboard: dashboardReducer,
    accountTypeMaster: accountTypeMasterReducer,
    accountLedger: accountLedgerReducer,
    [authService.reducerPath]: authService.reducer,
    [allUserService.reducerPath]: allUserService.reducer,
    [allValueChainCategoriesService.reducerPath]: allValueChainCategoriesService.reducer,
    [allValueChainsService.reducerPath]: allValueChainsService.reducer,
    [allAgentMasterService.reducerPath]: allAgentMasterService.reducer,
    [allUserRoleService.reducerPath]: allUserRoleService.reducer,
    [allUserGroupService.reducerPath]: allUserGroupService.reducer,
    [stateService.reducerPath]: stateService.reducer,
    [countryService.reducerPath]: countryService.reducer,
    [responsibilityCenterService.reducerPath]: responsibilityCenterService.reducer,
    [responsibilityGroupService.reducerPath]: responsibilityGroupService.reducer,
    [accountCategoryService.reducerPath]: accountCategoryService.reducer,
    [accountService.reducerPath]: accountService.reducer,
    [organizationMasterService.reducerPath]: organizationMasterService.reducer,
    [memberCategoryMasterService.reducerPath]: memberCategoryMasterService.reducer,
    [memberMasterService.reducerPath]: memberMasterService.reducer,
    [scenarioMasterService.reducerPath]: scenarioMasterService.reducer,
    [scripturalReferenceMasterService.reducerPath]: scripturalReferenceMasterService.reducer,
    [voucherTypeFinanceMasterService.reducerPath]: voucherTypeFinanceMasterService.reducer,
    [voucherTypeKarmaMasterService.reducerPath]: voucherTypeKarmaMasterService.reducer,
    [voucherFinanceService.reducerPath]: voucherFinanceService.reducer,
    [voucherKarmaService.reducerPath]: voucherKarmaService.reducer,
    [voucherParticipantService.reducerPath]: voucherParticipantService.reducer,
    [openingBalanceFinanceService.reducerPath]: openingBalanceFinanceService.reducer,
    [openingBalanceKarmaService.reducerPath]: openingBalanceKarmaService.reducer,
    [inventoryCategoryMasterService.reducerPath]: inventoryCategoryMasterService.reducer,
    [inventoryItemMasterService.reducerPath]: inventoryItemMasterService.reducer,
    [inventoryOpeningBalanceService.reducerPath]: inventoryOpeningBalanceService.reducer,
    [inventoryTransactionsService.reducerPath]: inventoryTransactionsService.reducer,
    [tokenMechanismMasterService.reducerPath]: tokenMechanismMasterService.reducer,
    [aiProcessingLogService.reducerPath]: aiProcessingLogService.reducer,
    [auditLogService.reducerPath]: auditLogService.reducer,
    [partyCategoryMasterService.reducerPath]: partyCategoryMasterService.reducer,
    [dashboardService.reducerPath]: dashboardService.reducer,
    [accountTypeMasterService.reducerPath]: accountTypeMasterService.reducer,
    [accountLedgerService.reducerPath]: accountLedgerService.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    })
      .concat(authService.middleware)
      .concat(allUserService.middleware)
      .concat(allValueChainCategoriesService.middleware)
      .concat(allValueChainsService.middleware)
      .concat(allAgentMasterService.middleware)
      .concat(allUserRoleService.middleware)
      .concat(allUserGroupService.middleware)
      .concat(stateService.middleware)
      .concat(countryService.middleware)
      .concat(responsibilityCenterService.middleware)
      .concat(responsibilityGroupService.middleware)
      .concat(accountCategoryService.middleware)
      .concat(accountService.middleware)
      .concat(organizationMasterService.middleware)
      .concat(memberCategoryMasterService.middleware)
      .concat(memberMasterService.middleware)
      .concat(scenarioMasterService.middleware)
      .concat(scripturalReferenceMasterService.middleware)
      .concat(voucherTypeFinanceMasterService.middleware)
      .concat(voucherTypeKarmaMasterService.middleware)
      .concat(voucherFinanceService.middleware)
      .concat(voucherKarmaService.middleware)
      .concat(voucherParticipantService.middleware)
      .concat(openingBalanceKarmaService.middleware)
      .concat(openingBalanceFinanceService.middleware)
      .concat(inventoryCategoryMasterService.middleware)
      .concat(inventoryItemMasterService.middleware)
      .concat(inventoryOpeningBalanceService.middleware)
      .concat(inventoryTransactionsService.middleware)
      .concat(tokenMechanismMasterService.middleware)
      .concat(aiProcessingLogService.middleware)
      .concat(auditLogService.middleware)
      .concat(partyCategoryMasterService.middleware)
      .concat(dashboardService.middleware)
      .concat(accountTypeMasterService.middleware)
      .concat(accountLedgerService.middleware)
  ,
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
